import React from 'react';

import PoweredBy from "./PoweredBy";

const FooterPoweredBy = () => {
    return (
        <div className="footer-powered-by">
            <PoweredBy />
        </div>
    );
};

export default React.memo(FooterPoweredBy);
